import './index.scss';
import 'components/select';


class AboutBox {
  constructor() {
    this.$aboutBox = $('.js-about-box');
    this.$aboutForm = $('.js-about-form', this.$aboutBox);
    this.$aboutBoxToggle = $('#edit-user-about', this.$aboutBox);
    this.$stateInput = $('#state_id', this.$aboutBox);
    this.$cityInput = $('#city_id', this.$aboutBox);
    this.bindAll();
  }

  _bindStateChange() {
    this.$stateInput.qselect('on', 'change', stateId => {
      this._onStateChange(stateId);
    });
  }

  _onStateChange(stateId) {
    Thor.City.get({}, {qs: {by_state: stateId}})
      .then(cities => {
        this.$cityInput
          .qselect('reset')
          .qselect('setOptions', cities);
      })
      .catch(err => {
        console.error(err);
        toastr.error('Oops, aconteceu algum erro!');
      });
  }

  _bindAboutForm() {
    this.$aboutForm.submit((event) => {
      event.preventDefault();

      const errorList = this.$aboutForm.children()
        .toArray()
        .filter((el) => $(el).hasClass('has-error'));

      if (errorList.length > 0) {
        toastr.error('Oops, parace que tem algo de errado com seus dados!');
        return;
      }

      const data = this.$aboutForm.serializeObject();

      if (!data.hasOwnProperty('user_profile')) {
        console.warn('The form data does not contain about info of the user');
        return;
      }

      const body = {data: {'user_profile': data['user_profile']}};
      if(!body.data['user_profile']['job']) {
        body.data['user_profile']['job'] = '';
      }
      Thor.UserProfile
        .update({}, body)
        .then(() => {
          $('.js-profile-job', this.$aboutBox)
            .text(data['user_profile']['job']);

          let city = $('.js-about-form').find('#city_id li.selected').text();
          let state = $('.js-about-form').find('#state_id li.selected').text();

          $('.js-profile-address', this.$aboutBox)
            .text(`${city} | ${state}`);

          $('.js-profile-resume', this.$aboutBox)
            .text(data['user_profile']['resume']);

          this.$aboutBoxToggle.prop('checked', false);

          toastr.success('Seu perfil foi atualizado com sucesso!');
        })
        .catch(err => {
          console.error(err);
          toastr.error('Oops, aconteceu algum erro!');
        });
    });
  }

  bindAll() {
    if (this.$aboutBox.length && this.$aboutBox.data().isSelf) {
      this._bindStateChange();
      this._onStateChange(this.$stateInput.qselect('getValue'));
    }
    this._bindAboutForm();
  }
}

(function () {
  'use strict';

  new AboutBox();
})();
